import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { InteractiveContent, UserActionValue, UserActionType, UserAction, Questions } from 'models';
import { TutorService } from 'src/app/_tutor/tutor.service';
import { SessionStorageKeys } from 'utility';
import { BrowserStorageService } from './browser-storage.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  isAuthenticated: boolean = false;

  constructor(
    private oidcSecurityService: OidcSecurityService,
    private router: Router,
    private tutor: TutorService,
    private browserStorage: BrowserStorageService
  ) { }

  login(survey: Questions = null) {
    if (!this.isAuthenticated) {
      this.saveRedirectUrl();
      this.saveSurveyToSessionStorage(survey);
      
      setTimeout(
        () => { this.oidcSecurityService.authorize(); },
        600
      )
    }
  }

  logOff(survey: Questions = null) {
    this.saveRedirectUrl();
    this.saveSurveyToSessionStorage(survey);
    
    setTimeout(
      () => { this.oidcSecurityService.logoffAndRevokeTokens().subscribe((result) => console.log(result)); },
      600
    )
  }

  saveRedirectUrl() {
    const redirectUrl = this.router.url;
    this.browserStorage.saveData(SessionStorageKeys.redirectUrlKey, redirectUrl, 'sessionStorage');
  }
  
  saveSurveyToSessionStorage(survey) {
    if (survey) {
      survey.forEach(s => {
        s.nextQuestion = null;
        s.prevQuestion = null;
      });

      try {
        this.browserStorage.saveData(SessionStorageKeys.surveyTmpSaveKey, JSON.stringify(survey), 'sessionStorage')
      }
      catch (err) {
        console.error("Errore durante il salvataggio temporaneo del questionario: ", err);
      }
    }
  }

  showLoginIsRequiredMsg(survey: Questions = null) {
    const dialogTxt:InteractiveContent[] = [
      {
        typo: 'str',
        str: 'Registrati gratuitamente per accedere a queste funzionalità, oppure effettua il login se sei già registrato.'
      },
      { typo: 'break' },
      { typo: 'break' },
      {
        typo: 'str',
        str: "La registrazione ti permette anche di effettuare il download del KID (il documento informativo sintetico obbligatorio) che trovi nella pagina di dettaglio di ogni prodotto e salvarlo nei preferiti, o vedere i contatti degli intermediari assicurativi più vicini autorizzati alla vendita."
      },
      { typo: 'break' },
      { typo: 'break' },
      { typo: 'break' },
      {
        typo: 'click',
        str: 'Registrazione',
        value: 0
      },
      { typo: 'break' },
      {
        typo: 'click',
        str: 'Login',
        value: 1
      },
      { typo: 'break' },
      {
        typo: 'click',
        str: 'Password smarrita',
        value: 2
      },
    ];

    const userActions: UserActionValue[] = [
      
      { action: { type: UserActionType.register }, value: 0 },
      { action: { type: UserActionType.login }, value: 1 },
      { action: { type: UserActionType.forgottenPassword }, value: 2 }
    ]

    this.tutor.showText('', "Attenzione", false, dialogTxt, userActions, 'info')
      .then(data => {
        if (typeof data === 'object') {
          var config = this.oidcSecurityService.getConfigurations()
          switch ((data as UserAction).type) {
            /** Per il momento, i tre user actions rimanderanno alla stessa pagina, eventualmente vedere se è possibile rimandare a pagine differenti */
            case UserActionType.register:
              window.open(config.pop().authority+"/Identity/Account/Register");
              break;
            case UserActionType.login:
              this.login(survey);
              break;
            case UserActionType.forgottenPassword:
              window.open(config.pop().authority+"/Identity/Account/ForgotPassword");
            break;
          }
        }
      })
  }
}
